// White-Label: these are populated at runtime from the company profile.
export let LOGO_URL = "";

export let FIRMA = {
  name: "",
  firma: "",
  strasse: "",
  plz_ort: "",
  land: "Deutschland",
  telefon: "",
  email: "",
  website: "",
};

export let DISCLAIMER = "";

// Brand RGB used inside jsPDF (contract pages). Updated by applyCompany().
export let BRAND_RGB = [200, 144, 122];

export const hexToRgb = (hex) => {
  const m = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec((hex || "").trim());
  return m
    ? [parseInt(m[1], 16), parseInt(m[2], 16), parseInt(m[3], 16)]
    : [200, 144, 122];
};

// Apply a loaded company profile to global branding + CSS theme variables.
export const applyCompany = (c) => {
  if (!c) return;
  FIRMA = {
    name: c.owner_name || "",
    firma: c.company_name || "",
    strasse: c.strasse || "",
    plz_ort: c.plz_ort || "",
    land: c.land || "Deutschland",
    telefon: c.telefon || "",
    email: c.email || "",
    website: c.website || "",
  };
  LOGO_URL = c.logo_base64 || "";
  DISCLAIMER = c.disclaimer || "";
  BRAND_RGB = hexToRgb(c.color_primary);
  if (typeof document !== "undefined") {
    const r = document.documentElement.style;
    if (c.color_primary) r.setProperty("--brand-primary", c.color_primary);
    if (c.color_primary_dark) r.setProperty("--brand-primary-dark", c.color_primary_dark);
    if (c.color_bg) r.setProperty("--brand-bg", c.color_bg);
    if (c.color_border) r.setProperty("--brand-border", c.color_border);
    if (c.color_ink) r.setProperty("--brand-ink", c.color_ink);
  }
};
